export enum IntervalEnum { YEAR = "YEAR", MONTH = "MONTH", WEEK = "WEEK", DAY = "DAY"}
